import { Intent, Tag } from "@blueprintjs/core";
import React from "react";
import { getPilStatus } from "utils/pilUtils";

type PilStatusChipProps = {
    readonly plannedMw: number | undefined;
    readonly projectSizeMw: number;
};

const PilStatusChip: React.FC<PilStatusChipProps> = ({
    plannedMw,
    projectSizeMw
}) => {
    const status = getPilStatus(plannedMw, projectSizeMw);

    if (status.kind === "upil") {
        return (
            <Tag minimal={true} round={true}>
                Unplanned
            </Tag>
        );
    }
    if (status.kind === "covered") {
        return (
            <Tag intent={Intent.SUCCESS} minimal={true} round={true}>
                Under PIL limit
            </Tag>
        );
    }
    return (
        <Tag intent={Intent.WARNING} minimal={true} round={true}>
            {status.overageMw.toLocaleString()} MW over PIL
        </Tag>
    );
};

export default PilStatusChip;
